var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-table',{attrs:{"items":_vm.certificates,"fields":_vm.fields,"responsive":"","hover":""},on:{"row-clicked":function (value) { return _vm.selectCertificate(value); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }